import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

const formatDate = (value) => {
  if (!value) return null;
  const [year, month, day] = String(value).split('-');
  return year && month && day ? `${day}/${month}/${year}` : value;
};

const EmploymentPeriodsCard = ({ employmentPeriods = [] }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
        borderRadius: 2,
        px: 2,
        py: 2.5,
        backgroundColor: theme.palette.primary.light,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
        <Box
          sx={{
            width: 4,
            height: 16,
            borderRadius: 4,
            backgroundColor: theme.palette.primary.main,
          }}
        />
        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: theme.palette.primary.main }}>
          Períodos laborales
        </Typography>
      </Box>
      <Typography variant="caption" sx={{ display: 'block', mb: 1.5, color: 'text.secondary' }}>
        Vigencias de la relación laboral del empleado.
      </Typography>

      {employmentPeriods.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          Sin períodos laborales registrados.
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {employmentPeriods.map((period) => {
            const active = Boolean(period.active);
            const startDate = formatDate(period.start_date);
            const endDate = formatDate(period.end_date);

            return (
              <Box
                key={period.id || period.start_date}
                sx={{
                  display: 'flex',
                  alignItems: { xs: 'flex-start', sm: 'center' },
                  justifyContent: 'space-between',
                  flexDirection: { xs: 'column', sm: 'row' },
                  gap: 1,
                  p: 1.25,
                  borderRadius: 1.5,
                  backgroundColor: '#FFFFFF',
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                }}
              >
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
                    Desde {startDate}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {endDate ? `Baja efectiva: ${endDate}` : 'Sin fecha de baja'}
                  </Typography>
                </Box>
                <Chip
                  size="small"
                  label={active ? 'Vigente' : 'Finalizado'}
                  color={active ? 'success' : 'default'}
                  variant={active ? 'filled' : 'outlined'}
                />
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default EmploymentPeriodsCard;
